import React, { Component, Fragment } from 'react';

import moment from 'moment';

import {
  // Button,
  Paper,
  Grid,
} from '@material-ui/core';
import MUIDataTable from "mui-datatables";

// import EnhancedTable from './components/EnhancedTable';
import metadata from '../metadata';
import {
  // Pie,
  Bar,
} from 'react-chartjs';

import './Admin.css';

const roles = [{
  value: 'counselor',
  label: 'Counselor',
}, {
  value: 'reporter',
  label: 'Reporter',
}, {
  value: 'guardian',
  label: 'Guardian',
}, {
  value: 'teacher',
  label: 'Teacher',
}, {
  value: 'nurse',
  label: 'Nurse',
}, {
  value: 'administator',
  label: 'Administrator',
}, {
  value: 'other',
  label: 'Other',
}]

class Admin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statistics: { age: {}, tShirtSize: {} },
      campers: [],
      enrollments: [],
      jobs: [],
    }
  }
  componentDidMount() {
    this.load();
    this.loadJobs();
  }

  load() {
    const params = new URLSearchParams(this.props.location.search);
    const token = params.get('token');

    return Promise.resolve()
      .then(() => {
        // https://stackoverflow.com/questions/53594391/preflight-cors-issue-on-serverless-aws-lamba-fucntions
        const url = `${metadata.apiUrl}/admin/enrollment`;
        const params = {
          method: 'GET',
          mode: 'cors',
          headers: {
            'x-api-key': metadata.apiKey,
            'Authorization': token,
          },
        };

        return fetch(url, params).then((response) => {
          if (response.status !== 200) {
            return Promise.reject(response);
          }
          return response.json();
        })
      })
      .then((res) => {
        const enrollments = res.data.map((item) => {
          Object.assign(item, {
            fullName: `${item.firstName} ${item.lastName}`,
            fullAddress: `${item.address.street}, ${item.address.city}, ${item.address.state} ${item.address.zipCode}`,
            camperCount: item.campers.length,
            appliedAt: new Date(item.createdAt).toLocaleString(),
          });
          item.campers.forEach((camper) => {
            // misc data fix
            camper.campViceCounselorPosition = camper.campViceCounselorPosition || 'no';
            camper.emergencyContact = `${item.fullName} ${item.primaryPhone}, ${item.secondaryPhone}`
            camper.height = formatHeight(camper.height);
            camper.primaryContactEmail = item.email;
          });
          return item;
        })

        const campers = res.data.reduce((data, item) => {
          return [...data, ...item.campers];
        }, []);

        this.setState({
          statistics: analyzeCampers(campers),
          campers,
          enrollments,
        });
        console.log(enrollments);
      })
      .catch(console.log);
  }

  loadJobs() {
    const params = new URLSearchParams(this.props.location.search);
    const token = params.get('token');

    return Promise.resolve()
      .then(() => {
        // https://stackoverflow.com/questions/53594391/preflight-cors-issue-on-serverless-aws-lamba-fucntions
        const url = `${metadata.apiUrl}/admin/job`;
        const params = {
          method: 'GET',
          mode: 'cors',
          headers: {
            'x-api-key': metadata.apiKey,
            'Authorization': token,
          },
        };

        return fetch(url, params).then((response) => {
          if (response.status !== 200) {
            return Promise.reject(response);
          }
          return response.json();
        })
      })
      .then((res) => {
        roles.forEach((role) => {
          const jobs = res.data
            .filter(item => item.id)
            .filter(item => item.roles.includes(role.value))
            .map((item) => {
              Object.assign(item, {
                appliedRoles: role.value, // item.roles.join(','),
                hasPhoto: item.photo ? 'Uploaded' : 'N/A',
                hasDriverLicense: item.driverLicense ? 'Uploaded' : 'N/A',
                hasInsuranceCard: item.waiverEmergencyInsuranceCardLink ? 'Uploaded' : 'N/A',
                fullAddress: `${item.address.street}, ${item.address.city}, ${item.address.state} ${item.address.zipCode}`,
                languageAbility: `Chinsese: ${item.language.chinese.join(', ')} | English: ${item.language.english.join(', ')}`,
                currentSchool: item.school ? `${item.school.name} - ${item.school.grade} - ${item.school.gpa}` : '',
                appliedAt: new Date(item.createdAt).toLocaleString()
              })
              return item;
            });

          this.setState({
            [role.value]: jobs,
          });
        });
      })
      .catch(console.log);
  }

  render() {
    return (
      <Fragment>
      <Grid container className="main" justify="center" spacing={16}>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className="paper-container">
            {
              roles.map((role, index)=>(
                <h4 key={index}>{role.label}: {(this.state[role.value] || []).length}</h4>
              ))
            }
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className="paper-container">
            <h4>Campers: {this.state.campers.length || 0}</h4>
            <h4>Boys: {this.state.statistics.male || 0}</h4>
            <h4>Girls: {this.state.statistics.female || 0}</h4>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className="paper-container">
            <h4>Camper's Age (as of {metadata.ageCheckDate})</h4>
            <Bar data={Object.keys(this.state.statistics.age).reduce((data, key) => {
                const item = this.state.statistics.age[key];
                data.labels.push(`${key}`);
                data.datasets[0].data.push(item);
                return data;
              }, { labels: [], datasets: [{ label: 'Age', data: [] }] })}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper className="paper-container">
            <h4>T-Shirt Sizes</h4>
            <Bar data={Object.keys(this.state.statistics.tShirtSize).reduce((data, key) => {
                const item = this.state.statistics.tShirtSize[key];
                data.labels.push(key);
                data.datasets[0].data.push(item);
                return data;
              }, { labels: [], datasets: [{ label: 'T-shirt size', data: [] }] })}
            />
          </Paper>
        </Grid>
      </Grid>
      <Grid container className="main" justify="center" spacing={8}>
        {this.renderCamperTable()}
        {this.renderEnrollmentTable()}

        { roles.map((role, index)=>{
          return <Fragment key={index}>
           {this.renderJobsTable(role.label, this.state[role.value])}
          </Fragment>
        }) }
      </Grid>
      </Fragment>);
  }

  renderEnrollmentTable() {
    const headers = [{
        name: 'fullName',
        label: 'Name',
        options: {
          filter: false,
        }
      },
      {
        name: 'email',
        label: 'Email',
        options: {
          filter: false,
        }
      },
      {
        name: 'primaryPhone',
        label: 'Phone #1',
        options: {
          filter: false,
        }
      },
      {
        name: 'secondaryPhone',
        label: 'Phone #2',
        options: {
          filter: false,
        }
      },
      {
        name: 'fullAddress',
        label: 'Address',
        options: {
          filter: false,
        }
      },
      {
        name: 'camperCount',
        label: 'Campers #',
        options: {
          filter: false,
        }
      },
      {
        name: 'appliedAt',
        label: 'Applied At',
        options: {
          filter: false,
        }
      },
    ];

    const onItemClick = (rowData, rowMeta) => {
      // const item = this.state.campers[rowMeta.rowIndex]
    }

    const options = {
      selectableRows: false,
      filterType: 'checkbox',
      onRowClick: onItemClick,
      rowsPerPageOptions: [10, 50, 100],
      downloadOptions: {
        filename: `Applications.csv`
      }
    };

    return (
      <Grid item xs={12}>
        <MUIDataTable
          title={'Enrollments'}
          data={this.state.enrollments}
          columns={headers}
          options={options}
        />
      </Grid>)
  }

  renderCamperTable() {
    const headers = [{
        name: 'chineseName',
        label: 'Chinese Name',
        options: {
          filter: false,
        }
      }, {
        name: 'firstName',
        label: 'First Name',
        options: {
          filter: false,
        }
      },
      {
        name: 'lastName',
        label: 'Last Name',
        options: {
          filter: false,
        }
      },
      {
        name: 'campViceCounselorPosition',
        label: 'Request to be VC'
      },
      {
        name: 'gender',
        label: 'Gender'
      },
      {
        name: 'allergyApplied',
        label: 'Allergy',
        options: {
          filter: false,
          display: false,
        }
      },
      {
        name: 'allergyMedication',
        label: 'Allergy Medication',
        options: {
          filter: false,
          display: false,
        }
      },
      {
        name: 'allergyAction',
        label: 'Allergy Action',
        options: {
          filter: false,
          display: false,
        }
      },
      {
        name: 'age',
        label: 'Age'
      },
      {
        name: 'height',
        label: 'Height'
      },
      {
        name: 'weight',
        label: 'Weight',
      },
      {
        name: 'roomWith',
        label: 'Request to Room with',
        options: {
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const max = 50;
            return (
              <Fragment>{(value || '').length > max ? `${value.substring(0, max)}...` : value}</Fragment>
            )
          }
        }
      },
      {
        name: 'birthday',
        label: 'DOB',
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: 'tShirtSize',
        label: 'T-Shirt Size',
        options: {
          display: false
        }
      },
      {
        name: 'emergencyContact',
        label: 'Emergency Contact',
        options: {
          filter: false,
        }
      },
      {
        name: 'primaryContactEmail',
        label: 'Contact Email',
        options: {
          filter: false,
        }
      },
      {
        name: 'chineseSchoolName',
        label: 'Chinese School Name',
        options: {
          filter: false,
          display: false
        }
      },
    ];

    const onItemClick = (rowData, rowMeta) => {
      // const item = this.state.campers[rowMeta.rowIndex]
    }

    const options = {
      selectableRows: false,
      filterType: 'checkbox',
      onRowClick: onItemClick,
      rowsPerPageOptions: [10, 50, 100],
      downloadOptions: {
        filename: `Campers Application.csv`
      }
    };

    return (
      <Grid item xs={12}>
        <MUIDataTable
          title={'Campers'}
          data={this.state.campers}
          columns={headers}
          options={options}
        />
      </Grid>)
  }

  renderJobsTable(inTitle, inData) {
    if (!inData || !Array.isArray(inData)) {
      return '';
    }
    const headers = [{
        name: 'chineseName',
        label: 'Chinese Name',
        options: {
          filter: false,
        }
      }, {
        name: 'firstName',
        label: 'First Name',
        options: {
          filter: false,
        }
      },
      {
        name: 'lastName',
        label: 'Last Name',
        options: {
          filter: false,
        }
      },
      {
        name: 'appliedRoles',
        label: 'Roles',
        options: {
          filter: false,
          display: false,
        }
      },
      {
        name: 'gender',
        label: 'Gender'
      },
      {
        name: 'email',
        label: 'Email',
        options: {
          filter: false,
        }
      },
      {
        name: 'phoneNumber',
        label: 'Phone Number',
        options: {
          filter: false,
        }
      },
      {
        name: 'birthday',
        label: 'DOB',
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: 'photo',
        label: 'Photo',
        options: {
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const link = `https://s3.amazonaws.com/summercamp-enrollments-2019/${value}`
            return (
              <div className="photo-container" onClick={()=>{window.open(link, '_blank')}}>
                <img src={link} alt="Uploaded"/>
              </div>
            )
          }
        }
      },
      {
        name: 'driverLicense',
        label: 'Driver License',
        options: {
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const link = `https://s3.amazonaws.com/summercamp-enrollments-2019/${value}`
            return (
              <div className="photo-container" onClick={()=>{window.open(link, '_blank')}}>
                <img src={link} alt="Uploaded"/>
              </div>
            )
          }
        }
      },
      {
        name: 'waiverEmergencyInsuranceCardLink',
        label: 'Insurance Card',
        options: {
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const link = `https://s3.amazonaws.com/summercamp-enrollments-2019/${value}`
            return (
              <div className="photo-container" onClick={()=>{window.open(link, '_blank')}}>
                <img src={link} alt="Uploaded"/>
              </div>
            )
          }
        }
      },
      {
        name: 'fullAddress',
        label: 'Address',
        options: {
          filter: false,
          display: false,
        }
      },
      {
        name: 'attendYears',
        label: 'Has Attended Before At',
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: 'servedAsCounselorYears',
        label: 'Has Served As Counselor Before At',
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: 'servedAsGuardianYears',
        label: 'Has Served As Guardian Before At',
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: 'servedAsNurseYears',
        label: 'Has Served As Nurse Before At',
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: 'servedAsReporterYears',
        label: 'Has Served As Reporter Before At',
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: 'servedAsTeacherYears',
        label: 'Has Served As Teacher Before At',
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: 'criminalHistory',
        label: 'Criminal',
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: 'programBookDescription',
        label: 'Program Book Description',
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: 'languageAbility',
        label: 'Language',
        options: {
          filter: false,
          display: false,
        }
      },
      {
        name: 'isVerizon',
        label: 'Has Verizon Phone',
        options: {
          filter: false,
          display: false,
        }
      },
      {
        name: 'facebookShareDaily',
        label: 'Facebookshare Daily',
        options: {
          filter: false,
          display: false,
        }
      },
      {
        name: 'currentSchool',
        label: 'Current School',
        options: {
          filter: false,
          display: false,
        }
      },
      {
        name: 'appliedAt',
        label: 'Applied At',
        options: {
          filter: false,
        }
      },
    ];

    const onItemClick = (rowData, rowMeta) => {
      // const item = this.state.campers[rowMeta.rowIndex]
    }

    const title = `${inTitle} Applications`;
    const options = {
      selectableRows: false,
      filterType: 'checkbox',
      onRowClick: onItemClick,
      rowsPerPageOptions: [10, 50, 100],
      downloadOptions: {
        filename: `${title}.csv`
      }
    };

    return (
      <Grid item xs={12}>
        <MUIDataTable
          title={title}
          data={inData}
          columns={headers}
          options={options}
        />
      </Grid>)
  }
}



export default Admin;

function analyzeCampers(campers) {
  const ageDiffDate = moment(metadata.ageCheckDate);
  const statistics = campers.reduce((data, camper) => {
    //
    if (camper.birthday) {
      camper.age = ageDiffDate.diff(moment(camper.birthday), 'year');
    }
    if (camper.age) {
      data.age[camper.age] = data.age[camper.age] || 0;
      data.age[camper.age]++;
    }
    if (camper.gender === 'male') {
      data.male++;
    } else
    if (camper.gender === 'female') {
      data.female++;
    }
    if (camper.tShirtSize) {
      data.tShirtSize[camper.tShirtSize] = data.tShirtSize[camper.tShirtSize] || 0;
      data.tShirtSize[camper.tShirtSize]++;
    }
    return data;
  }, {
    male: 0,
    female: 0,
    age: {},
    tShirtSize: {},
  });

  return statistics;
}

function formatHeight(inHeightString) {
  const numbers = inHeightString.replace(/([\D+])/g, ' ').replace(/ +/g, ' ').split(' ');

  return `${numbers[0]}'${(numbers[1] ? numbers[1] : '0')}${(numbers[2] ? `.${numbers[2]}` : '' )}"`;
}
